/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyProblemType {
  NoSalesContacts = "No_Sales_Contacts",
  MissingEmailDomain = "Missing_Email_Domain",
  DuplicateEmailDomain = "Duplicate_Email_Domain",
  DuplicateCompanyName = "Duplicate_Company_Name",
  PossibleDuplicateAccount = "Possible_Duplicate_Account",
  IncompleteAddress = "Incomplete_Address",
  MissingLatitude2fLongitude = "Missing_Latitude_2fLongitude",
  MissingPrimaryContact = "Missing_Primary_Contact",
  DuplicateSalesContactEmails = "Duplicate_Sales_Contact_Emails",
  DuplicateSalesContactNames = "Duplicate_Sales_Contact_Names",
  SalesContactOnMultipleCompanies = "Sales_Contact_on_Multiple_Companies",
  SalesContactNameOnMultipleCompanies = "Sales_Contact_Name_on_Multiple_Companies",
  SalesContactsDomainMismatch = "Sales_Contacts_Domain_Mismatch",
  MissingFreightVolume = "Missing_Freight_Volume",
  MissingTemperature = "Missing_Temperature",
}

export function instanceOfCompanyProblemType(value: any): boolean {
  for (const key in CompanyProblemType) {
    if (Object.prototype.hasOwnProperty.call(CompanyProblemType, key)) {
      if (
        CompanyProblemType[key as keyof typeof CompanyProblemType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyProblemTypeFromJSON(json: any): CompanyProblemType {
  return CompanyProblemTypeFromJSONTyped(json, false);
}

export function CompanyProblemTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyProblemType {
  return json as CompanyProblemType;
}

export function CompanyProblemTypeToJSON(
  value?: CompanyProblemType | null,
): any {
  return value as any;
}

export function CompanyProblemTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyProblemType {
  return value as CompanyProblemType;
}
